import { motion } from "framer-motion";
import * as React from "react";
import { useContext } from "react";
import { ViewContext } from "../constants/context.ts";
import { slideUp } from "../constants/framer.config.ts";

function Oracle2() {
  const { showView } = useContext(ViewContext);

  return (
    <motion.div {...slideUp(showView)} className="w-full">
      <div className="relative mx-4 rounded-[30px] lg:mt-[-20rem] py-40 max-md:p-4 bg-center bg-no-repeat bg-cover">
        {/* Top Section */}
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-[1.2fr_1fr] gap-8 border border-[#272727] p-12 max-md:p-4 rounded-3xl relative overflow-hidden bg-gradient-to-b from-black to-[#1E1E1E]">
          <div className="flex flex-col justify-center">
            <div className="text-2xl text-transparent bg-clip-text bg-gradient-to-r from-[#BEFFF6] to-[#0BB0C4] font-medium">
              Trade with Confidence
            </div>
            <div className="text-[#E3FFFF] text-[40px] md:text-4xl font-semibold mt-2 mb-4">
              The most <span>powerful toolkit</span>
            </div>
            <div className="text-white text-opacity-60 text-base md:text-lg font-normal space-y-4">
              <div>
                Streamlines charting by automatically plotting crucial data on your chart. A time-saver that eliminates guesswork, a powerful confluence tool which highlights everything you need to understand: price action, trend and volume strength, allowing you to act decisively in fast moving conditions.
              </div>
              <div>
                OracleAlgo offers three different indicators covering all of your favourite confluences such as delta volume, market structure shifts, EMAs, volume metric order blocks, key levels, trend candles, lines and channels as well as FVGS, VWAP + much more.
              </div>
            </div>
          </div>
          <div className="flex items-center justify-center">
            <img
              src="/images/oracle-img1.svg"
              alt="Oracle Chart"
              className="max-w-[350px] md:max-w-[420px] w-full rounded-xl shadow-lg object-contain"
              style={{ background: "#0B1B23" }}
            />
          </div>
        </div>

        {/* Bottom Section */}
        <div className="max-w-[1400px] mx-auto mt-11 grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Advanced Trend */}
          <div className="border border-[#272727] rounded-3xl p-8 md:p-10  bg-gradient-to-b from-black to-[#1E1E1E] flex flex-col h-full">
            <div className="text-2xl mb-1 text-transparent bg-clip-text bg-gradient-to-r from-[#BEFFF6] to-[#0BB0C4] font-medium">
              Execute with Precision
            </div>
            <div className="text-[#E3FFFF] text-[40px] md:text-3xl font-semibold mb-3">
              Advanced Trend
            </div>
            <div className="text-white text-opacity-60 md:text-lg font-normal mb-6 space-y-4">
              <div>
                Elevate your trading game and receive clarity on the charts with our adaptive trend channels, trend table, trend candles and trend lines to pinpoint optimal entries and exits, allowing you to stay ahead of market trends.
              </div>
              <div>
                With the market trajectory laid out in real time, it allows you to take action with conviction, without any hesitation.
              </div>
            </div>
            <div className="flex-1 flex items-end">
              <img
                src="/images/oracle-img2.svg"
                alt="Advanced Trend"
                className="w-full rounded-lg object-contain bg-[#0B1B23] max-h-[300px]"
                style={{ background: "none" }}
              />
            </div>
          </div>
          {/* Advanced Oscillator */}
          <div className="border border-[#272727] rounded-3xl p-8 md:p-10  bg-gradient-to-b from-black to-[#1E1E1E] flex flex-col h-full">
            <div className="text-2xl mb-1 text-transparent bg-clip-text bg-gradient-to-r from-[#BEFFF6] to-[#0BB0C4] font-medium">
              Master the Markets
            </div>
            <div className="text-[#E3FFFF] text-[40px] md:text-3xl font-semibold mb-3">
              Advanced Oscillator
            </div>
            <div className="text-white text-opacity-60 md:text-lg font-normal mb-6 space-y-4">
              <div>
                Our Advanced Oscillator detects delta volume, calculating the difference between inflows and outflows, shifts in market momentum and divergences.
              </div>
              <div>
                This deeper perspective gives you the insight to catch reversals early, ride trends longer, and stay one step ahead of the crowd.
              </div>
            </div>
            <div className="flex-1 flex items-end">
              <img
                src="/images/oracle-img3.svg"
                alt="Advanced Oscillator"
                className="w-full rounded-lg object-contain bg-[#0B1B23] max-h-[300px]"
                style={{ background: "none" }}
              />
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default Oracle2;
